import React from 'react';
import { Modal } from 'react-bootstrap';
import EditCategoryForm from '../../containers/form/CategoryForm/EditCategoryForm';
import './index.scss';

const EditCategoryModal = ({ show, category, onHide }) => (
  <Modal fullscreen="sm-down" show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>Editar Categoria</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {category && <EditCategoryForm category={category} setShowModal={onHide} />}
    </Modal.Body>
  </Modal>
);

export default EditCategoryModal;
